import React, { useContext, useEffect, useState } from 'react'
import { Col, Container, Image, Row } from 'react-bootstrap'
import logoLight from '../../assets/img/logo/main-logo-light.svg'
import logoDark from '../../assets/img/logo/main-logo-dark.svg'
import COLORS from '../../constants/color'
import './footer.scss'
import whiteLogo from '../../assets/img/logo/logo_equity_renkli-01.png'
import darkLogo from '../../assets/img/logo/logo_equity_beyaz-01.png'
import { ThemeContext } from "../../context/theme-context";
import { useTranslation } from "react-i18next";
const Footer = () => {
    const { t } = useTranslation();
    const currentTheme = useContext(ThemeContext).theme;
    const logo = currentTheme === 'dark' ? logoDark : logoLight;

    const [EquityRTLogo, setEquityRTLogo] = useState(whiteLogo);

    useEffect(() => {
        if (currentTheme === 'dark') {
            setEquityRTLogo(darkLogo);
        } else {
            setEquityRTLogo(whiteLogo);
        }
    }, []);

    return (
        <Container className='footer-container m-t-20 ' style={styles.footerContainer}>

            <Row className='footer-container-row'>

                <Col md='12' sm='12'>
                    <Image src={logo} fluid />
                    <Row>
                        <Col>
                            <div className='m-t-10 roboto-bold-16 color-text'>
                                {t('footer.mainTextHeader')}
                            </div>
                        </Col>
                    </Row>

                    <Row>
                        <Col>
                            <div className='m-t-10 roboto-regular-12 color-text' style={styles.footerContent}>
                                {t('footer.description')}
                            </div>
                        </Col>
                    </Row>
                </Col>

            </Row>

            <Row className='m-t-15'>

                <Col md='8' sm='8' xs='6'>
                    <div className='roboto-regular-12 color-text' style={styles.footerInfo}>
                        {/* Tahminler Rasyonet - Research Turkey tarafından sağlanmaktadır. */}
                    </div>
                </Col>

                <Col md='4' sm='4' xs='6'>
                    <div className='color-text roboto-medium-16' style={styles.footerInfoBrand}>
                        Powered By <Image src={EquityRTLogo} style={{ height: 42 }} />
                    </div>
                </Col>

            </Row>

        </Container>

    )
}

export default Footer;

const styles = {
    footerContainer: {
        position: 'absolute',
        left: 0,
        bottom: 0,
        right: 0,
        // margin: 'auto',
        display: 'contents',
    },

    footerInfoBrand: {

        fontSize: '18px',
        textAlign: 'right',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-end',
        alignItems: 'flex-end',
        gap: '5px',
    }

}
